import axios from "axios";

export const getAllBlogs = async () => {
  return await axios.get(
    `${process.env.REACT_APP_BLOG_BASE_URL}posts`,
    {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    } 
  );
};


export const getOneBlog = async (id) => {
    return await axios.get(
      `${process.env.REACT_APP_BLOG_BASE_URL}posts?slug=${id}`,
      {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      } 
    );
  };
  

